// extracted by mini-css-extract-plugin
module.exports = {"socialParentContainer":"media-module--socialParentContainer--1vBt_","socialMediaIcons":"media-module--socialMediaIcons--2INQN"};